module.exports = __webpack_public_path__ + "static/product-2-d92d32e1b8a179604120910c6f6d7cf3.png";